export default __webpack_public_path__ + "static/media/509.e38ae2ee.png";